module.exports = __webpack_public_path__ + "static/kobolds_mtg_clb-478ca931389b7dc410a27309a44e0b2e.jpg";